import { useState, useEffect } from "react";
import { produce } from "immer";
import { valueGetterWithErrorHandling, renderCellWithErrorBoundary } from "../cells/InvalidDataCell.js";
import { useColumnHeaderName } from "./useColumnHeaderName.js";
import { useGridCellStyle } from "./useGridCellStyle.js";
function useColumns({
  columns: initialColumns,
  pinnedColumns,
  visibleColumns,
  hasColumnSelection,
  isFlexible,
  onColumnsVisibilityUpdate
}) {
  const [visibleColumnNames, setVisibleColumnNames] = useState(visibleColumns);
  const allColumns = hasColumnSelection ? [...pinnedColumns ?? [], ...visibleColumnNames ?? []] : null;
  if (allColumns) {
    const sortedColumns = sortColumns(initialColumns, allColumns);
    initialColumns = hideColumns(sortedColumns, allColumns);
  }
  const namedColumns = useColumnHeaderName(initialColumns);
  const styledColumns = useGridCellStyle(namedColumns, isFlexible);
  const columns = styledColumns?.map((c) => ({
    ...c,
    ...c.renderCell ? { renderCell: renderCellWithErrorBoundary(c.renderCell) } : {},
    ...c.valueGetter ? { valueGetter: valueGetterWithErrorHandling(c.valueGetter) } : {}
  }));
  useEffect(() => {
    setVisibleColumnNames(visibleColumns);
  }, [visibleColumns?.join()]);
  function hideColumns(columns2, visibleColumnNames2) {
    return produce(columns2, (draft) => {
      draft.forEach((column) => {
        column.hide = visibleColumnNames2.length ? !visibleColumnNames2.includes(column.field) : true;
      });
    });
  }
  function sortColumns(columns2, visibleColumnNames2) {
    const sortedFieldNames = [.../* @__PURE__ */ new Set([...visibleColumnNames2, ...columns2.filter((c) => c).map((c) => c.field)])];
    return sortedFieldNames.map((name) => columns2.find((c) => c.field === name))?.filter((c) => c);
  }
  function handleVisibilityUpdate(visibleColumns2) {
    setVisibleColumnNames(visibleColumns2);
    if (onColumnsVisibilityUpdate) {
      onColumnsVisibilityUpdate(visibleColumns2);
    }
  }
  return {
    columns,
    onColumnsVisibilityUpdate: handleVisibilityUpdate
  };
}
export {
  useColumns
};
//# sourceMappingURL=useColumns.js.map
